const REFERRAL_REF_ID_KEY = "referral_ref_id";
const REFERRAL_SOURCE_KEY = "referral_source";

export function storeReferralFromUrl() {
    const params = new URLSearchParams(window.location.search);
    const refId = params.get("ref") || params.get("ref_id");
    const source = params.get("source");

    if (refId && refId.trim()) {
        localStorage.setItem(REFERRAL_REF_ID_KEY, refId.trim());

        if (source && source.trim()) {
            localStorage.setItem(REFERRAL_SOURCE_KEY, source.trim());
        } else {
            localStorage.setItem(REFERRAL_SOURCE_KEY, "referral");
        }
        return;
    }

    if (source && source.trim()) {
        localStorage.setItem(REFERRAL_SOURCE_KEY, source.trim());
    }
}

export function getStoredReferralPayload() {
    const refId = localStorage.getItem(REFERRAL_REF_ID_KEY);
    const source = localStorage.getItem(REFERRAL_SOURCE_KEY);

    return {
        ref_id: refId || null,
        source: source || null,
    };
}

export function clearStoredReferral() {
    localStorage.removeItem(REFERRAL_REF_ID_KEY);
    localStorage.removeItem(REFERRAL_SOURCE_KEY);
}
